import Footer from "../components/footer";
import Header from "../components/header";
import SideNav from "../components/sidenav";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../components/pageHeader";
import { Link, useNavigate } from "react-router-dom";
import debounce from 'lodash.debounce';

const InventoryAll = () => {
    const navigate = useNavigate();
    const [inventoryData, setInventoryData] = useState([]);
    const [artworkID, setArtworkID] = useState([]);
    const [artistID, setArtistID] = useState([]);
    const [statusID, setStatusID] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    const [newdata, setNewdata] = useState({
        artworkID: 0, artistID: 0, statusID: 0, filterChoiceID: 0
    });

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ArtworkList', setArtworkID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindArtistList', setArtistID);
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-StatusList', setStatusID);
    }, []);

    const fetchDataFiltered = async () => {
        const { artworkID, artistID, statusID } = newdata;
        const url = `https://igapi.heuristticminds.com/api/InventoryList/Get-GetInventoryListByFilter?artworkID=${artworkID}&artistID=${artistID}&statusID=${statusID}`;
        fetchData(url, setInventoryData);
    };

    useEffect(() => {
        fetchDataFiltered(); // Fetch filtered data when component mounts and when filter values change
    }, [newdata]);

    // Filter Data based on searchQuery
    useEffect(() => {
        const lowercasedFilter = searchQuery.toLowerCase();
        const filtered = inventoryData.filter(item =>
            (item.productTitle && item.productTitle.toLowerCase().includes(lowercasedFilter)) ||
            (item.artistName && item.artistName.toLowerCase().includes(lowercasedFilter)) ||
            (item.mrp !== undefined && item.mrp !== null && item.mrp.toString().toLowerCase().includes(lowercasedFilter)) ||
            (item.productCode !== undefined && item.productCode !== null && item.productCode.toString().toLowerCase().includes(lowercasedFilter))
        );
        setFilteredData(filtered);
    }, [searchQuery, inventoryData]);

    const onChangeHandle = (e) => {
        const { name, value } = e.target;
        setNewdata(prevState => ({
            ...prevState,
            [name]: parseInt(value, 10)
        }));
    };
   
    // Debounced search handler to avoid excessive re-renders
    const handleSearchChange = debounce((e) => {
         setSearchQuery(e.target.value);
    }, 300);
    

    const columns = [
        {
            name: "Code",
            selector: row => row.productCode,
            sortable: true,
            width: "80px",
        },                
        {
            name: "Artwork",
            cell: (row) => <img className="m-2" src={`../images/products/full/${row.image}`} alt=" " width="80px" />,
            width: "100px",
        },
        {
            name: "Artwork Title",
            //selector: row => `${row.productTitle} By ${row.artistName}`,
            sortable: true,
            width: "140px",
            cell: row => (
                <div style={{ whiteSpace: "pre-wrap" }}>
                    {row.productTitle}{"\n"}By {row.artistName}
                </div>
            ),
        },        
        {
            name: "Price",
            selector: (row) => row.price,
            width: "90px",
            cell: row => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {row.price}
                </div>
            ),
        },
        {
            name: "Disc",
            selector: (row) => `${row.discount}%`,
            width: "70px",
        },
        {
            name: "GST on Art",
            //selector: row => row.gstArtwork,
            sortable: true,
            width: "120px",
            cell: row => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {row.gstArtwork}
                </div>
            ),
        },
        {
            name: "Shipping",
            selector: row => row.shippingCost,
            sortable: true,
            width: "100px",
            cell: row => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {row.shippingCost}
                </div>
            ),
        },
        {
            name: "Ship GST",
            selector: row => row.shippingGSTRate,
            sortable: true,
            width: "100px",
            cell: row => (
                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    {row.shippingGSTRate}
                </div>
            ),
        },
        {
            name: "Created",
            selector: row => new Date(row.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            sortable: true,
            width: "100px",
        },        
        {
            name: "Action",
            cell: (row) => <>
                <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>
                <button className="btn btn-light me-2 tp" onClick={(event) => onEditClick(event, row.id)}>
                    <span className="tptitle">Edit</span>
                    <i className="bi bi-pencil-square"></i>
                </button>
                <button className="btn btn-light tp text-primary" onClick={(event) => onViewClick(event, row.id)}>
                    <span className="tptitle">View</span>
                    <i className="bi bi-eye-fill"></i>
                </button>
                <Link to={''} onClick={() => onDeleteClick(row.id)}>
                        
                        <img
                            src="/images/ImgDel.png"
                            alt="Delete"
                            
                            style={{ width: "25px", height: "25px" }}
                        />
                        
                    </Link>            
            </>
        },
    ];

    const onStatusClick = async (id) =>{
        
        const confirmed = window.confirm("Are you sure you want to change Inventory status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/InventoryList/Update-ChangeInventoryStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                fetchDataFiltered();
            }
        }
        catch {
        }

    }


    const onEditClick = (event, id) => {
        event.preventDefault();
        navigate(`/addInventory/${id}`);
    };

    const onViewClick = (event, id) => {
        event.preventDefault();
        navigate(`/viewInventoryDetails/${id}`);
    };
    const onDeleteClick = async(id) => {
        const confirmed = window.confirm("Are you sure you want to Delete Inventory Item ?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/InventoryList/Delete-DeleteTMInventoryDetails?id=' + id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                fetchDataFiltered();
            }
        }
        catch {
        }
    };

    const handleRefresh = () => {

    };

    
    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='All Inventory' icon='bi bi-people-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">List Of Inventory</div>
                                        <div className="card-body">
                                            <div className="row mb-4">
                                                <div className="col-sm-12">
                                                    <a href="/addInventory" className="btn btn-primary">
                                                        <i className="bi bi-plus-circle-fill"></i> Add Inventory
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-sm-3">
                                                    <select value={newdata.artworkID} onChange={onChangeHandle} name="artworkID" className="form-control form-select">
                                                        <option value={0}>--Select Artwork--</option>
                                                        {artworkID.map(aType => (
                                                            <option key={aType.id} value={aType.id}>{aType.artwork}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-sm-3">
                                                    <select value={newdata.artistID} onChange={onChangeHandle} name="artistID" className="form-control form-select">
                                                        <option value={0}>--Select Artist--</option>
                                                        {artistID.map(aName => (
                                                            <option key={aName.id} value={aName.id}>{aName.artist}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-sm-2">                                                
                                                <select value={newdata.statusID} onChange={onChangeHandle} name="statusID" className="form-control form-select">
                                                        <option value={0}>--Select Status--</option>
                                                        <option value={1}>Active</option>
                                                        <option value={2}>InActive</option>
                                                        
                                                    </select>
                                                        
                                                </div>
                                                <div className="col-sm-2">
                                                    <input type="text" name="search" onChange={handleSearchChange} className="form-control" placeholder="Text Search" />
                                                </div>
                                                <div className="col-sm-2">
                                                <button type="submit" onClick={handleRefresh} className="btn btn-primary w-50">Refresh</button>
                                                </div>
                                            </div>
                                                <DataTable columns={columns} data={filteredData} pagination />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );


};
export default InventoryAll;
